import React from 'react';
import Grid from '@material-ui/core/Grid';

import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import * as ROUTES from '@constants/routes';
import Success from '@components/Success';
import AnalyticsPixel from '@components/AnalyticsPixel';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const DocumentForm = (props) => {
  const { subtitle, helperText } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const imgStyle = {
    position: 'absolute',
    top: '38px',
    left: '28px',
    width: '70px',
    height: '28px',
  };
  const h2Style = {
    fontFamily: 'Roboto',
    fontSize: '24px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    marginTop: '0',
    marginBottom: '10px',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#444b62',
  };

  const handleClick = () => {
    history.push(ROUTES.LOGIN);
  };
  return (
    <Container>
      <AnalyticsPixel id="onb-accountCreated-success" />
      <img src={`${publicPath}/logo.svg`} style={imgStyle} alt="Logo de la empresa" />
      <Grid
        container
        spacing={4}
        item
        xs={12}
        justify="center"
        style={{ textAlign: 'center', width: '100%', margin: '0' }}
      >
        <Success
          imgStyle={{ marginTop: '185px' }}
          h2Style={h2Style}
          firstLine={t('Onboarding.MerchantOnboarding.merchantCreatedForm.title')}
          secondLine={subtitle || t('Onboarding.MerchantOnboarding.merchantCreatedForm.subtitle')}
          helperText={helperText || ''}
          tag="login"
          buttonText={t('Onboarding.MerchantOnboarding.merchantCreatedForm.button')}
          handleClick={handleClick}
          idButton="onb-accountCreated-login"
        />
      </Grid>
    </Container>
  );
};

export default DocumentForm;
